module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (91).48a7308f.jpg";